interface Props {
  documentName: string;
  path: string;
  icon?: JSX.Element;
  additionalClasses?: string;
}

const ViewDocument = ({
  documentName,
  path,
  icon,
  additionalClasses
}: Props): JSX.Element => {
  return (
    <div className={`flex-row view-document ${additionalClasses ?? ''}`}>
      {icon && <div className='links-widget-icon'>{<i>{icon}</i>}</div>}
      <a
        className='in-text'
        href={path}
        target='_blank'
        rel='noopener noreferrer'>
        {documentName}
      </a>
    </div>
  );
};

export default ViewDocument;
